import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const video = getSharedAsset('5g-mec-and-smart-venues.mp4', 'demos', 'videos')
const poster = getSharedAsset('5g-mec-and-smart-venues.png', 'demos', 'posters')
const monolith = getSharedAsset('5g-mec-and-smart-venues.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('jigspace.png', 'demos', 'thumbnails')

export const mecAndSmartVenues: IDemo = {
  type: E3DDemoNameVals.mecAndSmartVenues,
  id: DemoIds.mecAndSmartVenues,
  video,
  poster,
  monolith,
  end: {
    header: '5G MEC and Smart Venues.',
    body:
      'CrowdVision uses sensors to generate highly detailed pictures of crowds in public places. This normally requires massive infrastructure. Using Verizon 5G Edge and AWS Wavelength for processing and backbone reduces that requirement, opening up new opportunities.',
    nextDemoText: 'Streamline prototyping using AR.',
    nextDemo: E3DDemoNameVals.jigspace,
    nextDemoId: DemoIds.jigspace,
    nextDemoThumbnail,
    previousDemoId: DemoIds.aerialApplications
  }
}
